import React, { useMemo } from "react";
import OnSubmitValidationError from "../../../components/FormComponents/OnSubmitValidationError";
import { connect } from "react-redux";
import * as interviewActions from "../../../actions/interviewActions";
import { FastField, Field, Formik } from "formik";
import * as formsService from "../../../services/formsService";
import { validationSchema } from "../InterviewPatientInfoScreening/validationSchema";
import { YesNoButtons } from "../../../components/FormComponents/YesNoButtons";
import { CurrencyInputField } from "@coverme/forms";
import { WizardButtonsField } from "../Components/WizardButtons";

function IncomeField({ name, title, getErrors, getValidationState, isRequired, setFieldValue }) {
    return (
        <div className="form-control m-input">
            <FastField
                name={name}
                render={({ field }) => (
                    <CurrencyInputField
                        {...field}
                        id={field.name}
                        value={field.value}
                        errorMessage={getErrors(field)}
                        validState={getValidationState(field)}
                        required={isRequired(field)}
                        title={title}
                        changeEvent={e => {
                            setFieldValue(field.name, e);
                        }}
                    />
                )}
            />
        </div>
    );
}

class KdmcFinancialAssistance extends React.Component {
    render() {
        const {
            onError,
            patientFullName,
            navigateToNextPage,
            navigateToPreviousPage,
            financialAssistance,
        } = this.props;
        const initialValues = financialAssistance;
        return (
            <Formik
                initialValues={initialValues}
                onSubmit={this.onSubmit}
                render={props => {
                    const { setFieldValue, setFieldTouched, resetForm, handleSubmit, errors, touched, values } = props;
                    const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                    const getErrors = formsService.getErrors.bind(this, errors);
                    const isRequired = formsService.isRequired.bind(this, validationSchema, values);

                    return (
                        <form className="wizard-form">
                            <OnSubmitValidationError callback={onError} />
                            <div className="form-section">
                                <div className="form-control">
                                    <YesNoButtons
                                        name="isCatastrophicIllness"
                                        title={`Does ${patientFullName} have a catastrophic illness where medical bills are likely to exceed the family's gross income?`}
                                        getErrors={getErrors}
                                        getValidationState={getValidationState}
                                        isRequired={isRequired}
                                        {...props}
                                    />
                                </div>
                            </div>
                            <WizardButtonsField
                                shouldAutoNavigate={false}
                                navigateToNextPage={navigateToNextPage}
                                navigateToPreviousPage={navigateToPreviousPage}
                            />
                        </form>
                    );
                }}
            />
        );
    }

    onSubmit = formData => {
        this.props.onSubmit(formData);
    };
}

export const InterviewKdmcContainer = connect(
    state => ({
        patientFullName: state.interview.entry.patient.fullName,
        patientAge: state.interview.entry.patient.age,
        financialAssistance: state.interview.financialAssistance,
    }),
    dispatch => ({
        onSubmit: data => dispatch(interviewActions.setPatientFinancialAssistanceInfo(data)),
        onError: () => dispatch(interviewActions.setInterviewError("info")),
    })
)(KdmcFinancialAssistance);
